import { BasicFilterSelect, ALIGNMENT } from 'ui/selects';
import { getAllTimeZones, getTimeZoneMenuDisplay } from '../helpers';
import { TimeZoneTrigger } from './TimeZoneTrigger';

export type TimeZonePickerProps = {
  /** Current time zone of user */
  timeZone: string;
  /** Function run when new time zone is selected.
   * Returned time zone is the regional name
   * (e.g. "America/Los_Angeles") */
  onTimeZoneChange?: (newTimeZone: string[]) => void;
  /** Whether the picker is disabled */
  isDisabled?: boolean;
  horizontalAlignment?: ALIGNMENT;
};

export const TimeZonePicker = ({
  isDisabled = false,
  timeZone,
  onTimeZoneChange,
  horizontalAlignment = ALIGNMENT.LEFT,
  ...props
}: TimeZonePickerProps) => {
  const timezones = getAllTimeZones().map((tz) => {
    return {
      id: tz,
      label: getTimeZoneMenuDisplay(tz),
      value: tz,
    };
  });
  return (
    <BasicFilterSelect
      isDisabled={isDisabled}
      defaultValues={[timeZone]}
      options={timezones}
      id="time-zone-picker"
      Trigger={TimeZoneTrigger}
      onSelect={onTimeZoneChange}
      horizontalAlignment={horizontalAlignment}
      inputContent={{ filterPlaceholder: 'Search all time zones' }}
      data-value={timeZone}
      {...props}
    />
  );
};
